<template>
  <div id="main-navbar" class="navbar navbar-expand-lg navbar-light fixed-top p-0">
    <router-view name="header" @on-go-to-main="changeToHomeTab()"></router-view>
  </div>
  <div id="main" class="d-flex flex-fill flex-row align-items-stretch">
    <div id="menu" class="d-flex flex-row">
      <div id="main-menu" class="sidenav flex-fill" :style="menuStyle">
        <!-- Menu Tab -->
        <div class="menutabcontainer">
          <div class="menutabs" v-if="isShowFav">
            <input
              v-model="menuToggle"
              @change="menuToggleChangeValue"
              type="radio"
              id="radio-1"
              name="menutabs"
              :checked="menuToggle == '0'"
              value="0"
            />
            <label class="menutab" for="radio-1">{{ t("labels.menu") }}</label>
            <input
              v-model="menuToggle"
              @change="menuToggleChangeValue"
              type="radio"
              id="radio-2"
              name="menutabs"
              :checked="menuToggle == '1'"
              value="1"
            />
            <label class="menutab" for="radio-2">{{ t("labels.favMenu") }}</label>
            <span class="glider"></span>
          </div>
          <div v-else class="menutabs" style="background-color: rgb(239, 242, 244)"></div>
          <button class="menutoggler" @click.prevent="collapseAllMenuLink()">
            <i :class="currentMenuCollapseToggleClass"></i>
          </button>
        </div>
        <div class="menu-list" v-if="menuToggle == '0'">
          <div class="menu-item">
            <div class="menu-header">
              <span class="menu-title">{{ t("menuNames.userManagement") }}</span>
            </div>
          </div>
          <div class="menu-item">
            <div class="menu-header">
              <span class="menu-title">{{ t("menuNames.codeManagement") }}</span>
            </div>
          </div>
          <div class="menu-item">
            <div class="menu-header">
              <span class="menu-title">{{ t("menuNames.menuManagement") }}</span>
            </div>
          </div>
        </div>
        <div class="menu-list" v-else-if="menuToggle == '1'">
          <router-view name="favMenu" @click="openTab"></router-view>
        </div>
      </div>
      <div style="height: 48px; background: #d8dbe2">
        <button class="toggler" @click.prevent="toggleMenu">
          <!-- <i :class="['fas', iconDirection]"></i> -->
          <i :class="[iconDirection]"></i>
        </button>
      </div>
    </div>
    <div class="tab-control">
      <button class="nav-inner-button btnPre" @click.prevent="changeTabHandler('previous')"></button>
      <button class="nav-inner-button btnNext" @click.prevent="changeTabHandler('next')"></button>
      <button class="nav-inner-button btnCloseAll" @click.prevent="closeAllTab()"></button>
    </div>
    <div id="main-content" ref="main" class="d-flex flex-fill flex-column" :style="mainStyle">
      <b-tabs v-model="activeTabIndex" class="contentsTab-wrap">
        <b-tab v-for="tab in getTabList" :key="tab.name" lazy-once>
          <template #title>
            <div v-if="tab.name != 'Home'" class="tab-unit">
              <span>{{ tab.name }}</span>
              <button @click.stop="closeTab(tab.name)" title="Close Tab"></button>
            </div>
            <div v-else>
              <img src="/images/icon_tab_home.svg" class="_navi-home" />
            </div>
          </template>
          <component v-if="tab.component" :is="tab.component" v-bind="tab.props" />
          <div class="text-center" v-else>
            <!-- <h1 style="margin-top: 15px;">Welcome to Singlex RaaS</h1> -->
            <img src="/images/dummy.png" />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script lang="ts">
  import {
    computed,
    defineComponent,
    onBeforeMount,
    onMounted,
    ref,
    watchEffect,
    markRaw,
    watch,
    defineAsyncComponent,
  } from "vue";
  import { emitter } from "@/store/PubSub";
  import { useStore } from "@/store";
  import { isInnerTab } from "@/side-bar-items";
  import { useRoute, useRouter } from "vue-router";
  import type { InnerTabProps } from "@/types/interface";
  import { popup } from "@/components/popup/Popup";
  import { useI18n } from "vue-i18n";
  const DashboardInnerTab = defineAsyncComponent(() => import("../pages/DashboardInnerTab.vue"));

  export default defineComponent({
    name: "DefaultInnerTabLayout",
    props: {
      width: {
        type: Number,
        required: false,
        default: 240,
      },
      format: {
        type: String,
        required: false,
        default: "push",
        validator: (value: string) => ["push", "full", "overlay"].indexOf(value) > -1,
      },
      direction: {
        type: String,
        required: false,
        default: "left",
        validator: (value: string) => ["left", "right"].indexOf(value) > -1,
      },
      totalInnerTab: {
        type: Number,
        required: false,
        default: 15,
      },
    },
    setup(props) {
      const store = useStore();
      const { t } = useI18n();
      const opened = ref(true);
      const route = useRoute();
      const router = useRouter();

      const openTabs = ref([]);
      const activeTabIndex = ref(0);
      const menuToggle = ref("0");
      const menuCollapseToggle = ref("menuexpand");
      const isInitial = ref(true);

      onMounted(() => {
        if (localStorage.getItem("menuToggle")) {
          menuToggle.value = localStorage.getItem("menuToggle");
        }

        initialTabList();
      });

      const initialTabList = (isCloseAll = false) => {
        if (isCloseAll) {
          openTabs.value = [];
          localStorage.removeItem("tabMenuId");
          localStorage.removeItem("focusedTabId");
          openTabs.value.push({
            name: "Home",
            path: "Home",
            component: markRaw(DashboardInnerTab),
          });
        } else {
          openTabs.value.push({
            name: "Home",
            path: "Home",
            component: markRaw(DashboardInnerTab),
          });
          let tabMenuId = localStorage.getItem("tabMenuId")?.split("|") ?? [];
          let lstMenu = store.getters.leftMenuList
            .map(e => {
              return e.children.map(e1 => {
                let index = tabMenuId.findIndex(id => id == e1.id);
                if (index >= 0) {
                  return {
                    menuLevel1Name: e.name,
                    menuName: e1.name,
                    menuId: e1.id,
                    path: e1.route.path,
                    grant: e1.route.meta.grant,
                    desc: e1.desc,
                    type: e1.type,
                    order: index,
                  };
                }
              });
            })
            .flatMap(e => e) // merge array
            .filter(e => e) // filter null object
            .sort((a, b) => a.order - b.order); // order by ASC

          lstMenu.forEach(e => {
            openTab(
              e.path,
              {
                levelMenuName: e.menuLevel1Name,
                menuName: e.menuName,
                menuDesc: e.desc,
                menuType: e.type,
                menuId: e.menuId,
                grantType: e.grant,
              },
              true
            );
          });

          setTimeout(() => {
            let focusedTabId = localStorage.getItem("focusedTabId");
            if (focusedTabId) {
              let tabIndex = openTabs.value.findIndex(e => e.menuId == focusedTabId);
              if (tabIndex >= 0) {
                activeTabIndex.value = tabIndex;
              }
            }
            isInitial.value = false;
          }, 60);
        }
      };

      function setFocusedTabId(menu) {
        if (menu?.menuId) {
          localStorage.setItem("focusedTabId", menu.menuId);
        }
      }

      function setTabMenuId() {
        let tabIdList = openTabs.value
          .filter(e => e.name != "Home")
          .map(e => e.menuId)
          .join("|");

        if (tabIdList) {
          localStorage.setItem("tabMenuId", tabIdList);
        }
      }

      function openTab(path, innerTabProps: InnerTabProps, isInitial = false) {
        if (openTabs.value.length <= props.totalInnerTab) {
          handleOpenInnerTab(path, innerTabProps, isInitial);
        } else {
          popup(t("errors.exceedNumberInnerTab"));
        }
      }

      function handleOpenInnerTab(path, innerTabProps: InnerTabProps, isInitial = false) {
        const { menuName, menuType, menuId } = innerTabProps;

        // menuType이 없거나 "T"가 아니면 기본값을 "T"로 설정
        const effectiveMenuType = menuType || "T";

        if (isInnerTab(effectiveMenuType)) {
          const existingIndex = openTabs.value.findIndex(tab => tab.path === path);
          if (existingIndex >= 0) {
            if (!isInitial) {
              activeTabIndex.value = existingIndex;
              setFocusedTabId(openTabs.value[existingIndex]);
            }
          } else {
            // 모든 경로에 대해 기본 컴포넌트 사용 (sidebarItems는 더 이상 사용하지 않음)
            openTabs.value.push({
              name: menuName,
              path: path,
              component: markRaw(DashboardInnerTab),
              menuId: menuId,
              props: { innerTabProps },
            });

            if (!isInitial) {
              setTimeout(() => {
                activeTabIndex.value = openTabs.value.length - 1;
                setFocusedTabId(openTabs.value[openTabs.value.length - 1]);
                setTabMenuId();
              }, 50);
            }
          }
        } else {
          router.push(path);
        }
      }

      function closeTab(tabName) {
        let index = openTabs.value.findIndex(e => e.name.toString().toLowerCase() == tabName.toString().toLowerCase());

        if (index >= 0) {
          openTabs.value.splice(index, 1);
          setTabMenuId();
        }
      }

      const menuDirection = computed(() => {
        return props.direction === "right" ? { right: 0 } : { left: 0 };
      });

      const iconDirection = computed(() => {
        // return opened.value ? "fa-angle-left" : "fa-angle-right";
        return opened.value ? "hide" : "show";
      });

      const mainStyle = computed(() => {
        //const marginLeft = props.format === "full" ? "100%" : `${props.width}px`;
        const width = props.format === "full" ? "100%" : `calc( 100% - ${props.width}px )`;
        return {
          // marginLeft: opened.value ? marginLeft : "0",
          width: opened.value ? width : "100%",
        };
      });

      const menuStyle = computed(() => {
        const width = props.format === "full" ? "100%" : `${props.width}px`;
        return {
          width: opened.value ? width : "0",
        };
      });

      const getTabList = computed(() => {
        return openTabs.value;
      });

      const theme = computed(() => {
        return store.getters.tenantColor;
      });

      const toggleMenu = () => {
        opened.value = !opened.value;
      };

      const showMenu = () => {
        opened.value = true;
      };

      const changeTabHandler = direction => {
        switch (direction) {
          case "previous": {
            if (activeTabIndex.value - 1 >= 0) {
              activeTabIndex.value = activeTabIndex.value - 1;
            }

            return;
          }
          case "next": {
            if (activeTabIndex.value + 1 < openTabs.value.length) {
              activeTabIndex.value = activeTabIndex.value + 1;
            }

            return;
          }
        }
      };

      const closeAllTab = () => {
        initialTabList(true);
      };

      // DynamicSidebar에서 메뉴 클릭 시 호출되는 함수
      const handleMenuClick = (event: CustomEvent) => {
        const { path, innerTabProps } = event.detail;
        openTab(path, innerTabProps);
      };

      const collapseAllMenuLink = () => {
        let menuClassName = "";
        let menuItemsClassName = "";

        if (menuCollapseToggle.value == "menuexpand") {
          menuClassName = "menu-link--collapse";
          menuItemsClassName = "menu-items--collapse";
          menuCollapseToggle.value = "menucollapse";
        } else {
          menuClassName = "menu-link--expand";
          menuItemsClassName = "menu-items--expand";
          menuCollapseToggle.value = "menuexpand";
        }

        const menuList = document.querySelectorAll("[data='parent-menu']");
        const menuItemsList = document.querySelectorAll("[data='child-menu']");

        menuList.forEach(div => {
          if (menuClassName == "menu-link--collapse") {
            div.classList.remove("menu-link--expand");
            div.classList.add(menuClassName);
          } else {
            div.classList.remove("menu-link--collapse");
            div.classList.add(menuClassName);
          }
        });

        menuItemsList.forEach(itemDiv => {
          if (menuItemsClassName == "menu-items--collapse") {
            itemDiv.classList.remove("menu-items--expand");
            itemDiv.classList.add(menuItemsClassName);
          } else {
            itemDiv.classList.remove("menu-items--collapse");
            itemDiv.classList.add(menuItemsClassName);
          }
        });
      };

      const changeToHomeTab = () => {
        activeTabIndex.value = 0;
      };

      const menuToggleChangeValue = () => {
        localStorage.setItem("menuToggle", menuToggle.value);
      };

      const isShowFav = computed(() => {
        return store.getters.mainScreenId == "3";
      });

      const currentMenuCollapseToggleClass = computed(() => {
        return menuCollapseToggle.value;
      });

      onMounted(() => {
        emitter.on("showLeftMenu", showMenu);

        // DynamicSidebar의 메뉴 클릭 이벤트 리스너 추가
        window.addEventListener("menu-click", handleMenuClick);
      });

      onBeforeMount(() => {
        emitter.off("showLeftMenu");

        // 이벤트 리스너 제거
        window.removeEventListener("menu-click", handleMenuClick);
      });

      watchEffect(() => {
        switch (theme.value) {
          case "SKYBLUE":
            document.documentElement.style.setProperty("--main-color", "#019798");
            break;
          case "BLUE":
            document.documentElement.style.setProperty("--main-color", "#006dcd");
            break;
          case "GREEN":
            document.documentElement.style.setProperty("--main-color", "#0b8059");
            break;
          case "PURPLE":
            document.documentElement.style.setProperty("--main-color", "#313191");
            break;
          // HDHyundai Custom
          case "HDBLUE":
            document.documentElement.style.setProperty("--main-color", "#00A4E0");
            break;
          default:
            document.documentElement.style.setProperty("--main-color", "#a50034");
            break;
        }
      });

      watch(activeTabIndex, index => {
        if (!isInitial.value) {
          if (index != 0) {
            setFocusedTabId(openTabs.value[index]);
          } else {
            localStorage.removeItem("focusedTabId");
          }
        }
      });

      return {
        opened,
        menuDirection,
        iconDirection,
        mainStyle,
        menuStyle,
        toggleMenu,
        showMenu,
        openTab,
        activeTabIndex,
        getTabList,
        closeTab,
        menuToggle,
        isShowFav,
        collapseAllMenuLink,
        currentMenuCollapseToggleClass,
        changeTabHandler,
        closeAllTab,
        changeToHomeTab,
        t,
        menuToggleChangeValue,
      };
    },
  });
</script>
<style lang="scss">
  @use "@/assets/styles/layout" as *;
  @use "@/assets/styles/admin" as *;
  @use "@/assets/styles/grid-table" as *;
</style>
